import React from 'react';

const RefundPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gray-900 text-white">
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600"></div>
        <div className="max-w-4xl mx-auto px-4 py-16">
          <div className="text-center">
            <img 
              src="/clawbrand_logo_color.png" 
              alt="ClawBrand AI" 
              className="h-16 mx-auto mb-6"
            />
            <h1 className="text-4xl font-bold mb-4">Refund Policy</h1>
            <p className="text-gray-300">Last updated: {new Date().toLocaleDateString()}</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our 30-Day Money-Back Guarantee</h2>
            <p className="text-gray-700 mb-6">
              At BrandScapes AI, we're confident you'll love our AI-powered mockup generator. That's why we offer a 
              straightforward 30-day money-back guarantee. If you're not completely satisfied with BrandScapes AI, 
              we'll refund your purchase - no questions asked.
            </p>

            <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-lg mb-8">
              <h3 className="text-xl font-bold text-green-800 mb-3">✓ 100% Risk-Free Trial</h3>
              <p className="text-green-700">
                Try BrandScapes AI for a full 30 days. If it doesn't transform your marketing workflow, 
                simply contact us for a full refund.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">How Our Refund Policy Works</h2>
            
            <h3 className="text-xl font-semibold text-gray-800 mb-3">1. Eligibility</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
              <li>Refund requests must be made within 30 days of your purchase date</li>
              <li>Applies to all BrandScapes AI subscription plans (Professional and Agency)</li>
              <li>One refund per customer account</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">2. Refund Process</h3>
            <p className="text-gray-700 mb-4">To request a refund:</p>
            <ol className="list-decimal pl-6 text-gray-700 mb-6 space-y-2">
              <li>Email our support team at support@brandscapesai.com</li>
              <li>Include your order number and purchase email</li>
              <li>We'll process your refund within 5-7 business days</li>
              <li>You'll receive a confirmation email once the refund is processed</li>
            </ol>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">3. What Happens After a Refund</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
              <li>Your BrandScapes AI account will be deactivated</li>
              <li>Access to all features and saved mockups will be removed</li>
              <li>Any downloaded mockups remain yours to keep</li>
              <li>You can repurchase at any time in the future</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Exceptions</h2>
            <p className="text-gray-700 mb-4">Our refund policy does not apply to:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
              <li>Purchases made more than 30 days ago</li>
              <li>Accounts that violate our Terms of Service</li>
              <li>Repeated refund requests from the same individual</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Commitment to You</h2>
            <p className="text-gray-700 mb-6">
              We stand behind BrandScapes AI because we know it delivers exceptional value. Our goal is your success, 
              and we're committed to ensuring you have a positive experience. If you ever have concerns or need assistance, 
              our support team is here to help you get the most out of BrandScapes AI.
            </p>

            <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg">
              <h3 className="text-lg font-bold text-gray-800 mb-3">Need Help?</h3>
              <p className="text-gray-700 mb-3">
                Before requesting a refund, consider reaching out to our support team. We're often able to resolve 
                issues quickly and help you unlock the full potential of BrandScapes AI.
              </p>
              <p className="text-gray-700">
                <strong>Contact Support:</strong> support@brandscapesai.com
              </p>
            </div>

            <div className="mt-8 p-6 bg-gray-100 rounded-lg">
              <p className="text-sm text-gray-600 text-center">
                This refund policy is part of our commitment to customer satisfaction. 
                For questions about refunds or our policies, please contact support@brandscapesai.com.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 mt-16">
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600"></div>
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="text-center">
            <p className="text-sm">
              © {new Date().getFullYear()} BrandScapes AI. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RefundPolicy;
